import {RootDesc} from "@ui/descriptions/RootDesc";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const RootInput = (props) => {
  const {
    width,
    label,
    type,
    value,
    required,
    onChange,
    disabled,
    placeholder,
    tabIndex,
    onKeyDown,
    autoComplete,
  } = props;

  const {isMobile} = useSelector((state) => state.common.settings);

  return (
    <label className={styles.rootInput}>
      <RootDesc>
        <b
          className={"phone:block phone:w-[100%]"}
          dangerouslySetInnerHTML={{__html: label}}
        />
      </RootDesc>

      <RootDesc>
        <input
          autoComplete={autoComplete || "off"}
          placeholder={placeholder}
          type={type}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown ? onKeyDown : undefined}
          aria-label={label}
          required={required}
          disabled={disabled}
          tabIndex={tabIndex ? tabIndex : undefined}
          style={isMobile ? {width: "100%"} : {width: `${width}rem`}}
        />
      </RootDesc>
    </label>
  );
};
